export enum ConditionType {
	featureFlag = 'featureFlag',
	featureGate = 'featureGate',
	buildRange = 'buildRange',
}

type ConditionBase = {
	type: ConditionType;
};

export type FeatureFlagCondition = ConditionBase & {
	affectedFeatureFlagValue: string | boolean;
	featureFlagKey: string;
};

export type FeatureGateCondition = ConditionBase & {
	affectedFeatureGateValue: boolean;
	featureGateKey: string;
};

export type BuildRangeCondition = ConditionBase & {
	buildRange: [string, string];
};

export type Condition = FeatureFlagCondition | FeatureGateCondition | BuildRangeCondition;

export type RemoteAction = {
	conditions: Condition[];
	enabled: boolean;
	id: string;
	name: string;
};

export type RemoteActionsResponse = {
	lastUpdatedAt: number;
	remoteActions: RemoteAction[];
};

export type GetFeatureFlagValue = (key: string) => unknown;
export type GetFeatureGateValue = (key: string) => boolean;

export type ProductData = {
	getBuildInfoFromKey: (buildKey: string) => {
		buildNumber: number;
		buildType: string;
	};
	getBuildKey: () => string;
	getFeatureFlagValue: GetFeatureFlagValue;
	getFeatureGateValue?: GetFeatureGateValue;
};

export type Product = string;

export type RemoteActionMetas = {
	attemptCounts: number;
	lastPerformAttemptedAt: number;
};

export type RemoteActionsMetas = {
	[id: string]: RemoteActionMetas;
};

export type RemoteActionsIndexedById = {
	[id: string]: RemoteAction;
};

export type RemoteActionCallback = (action: RemoteAction, meta: RemoteActionMetadata) => void;

export type RemoteActionMetadata = {
	attempts: number;
	lastAttemptedAt?: number;
};
